export const paymentProviders = {
  DATACASH: 2,
  PAYPAL: 10,
  UNIFIED_PAYMENT: 11,
};

export const paymentBrands = {
  VISA: 'visa',
  MASTERCARD: 'mastercard',
  PAYPAL: 'paypal',
  UNIFIED_PAYMENT: 'UnifiedPayment',
};
